import React from 'react';
import { useFormContext } from 'react-hook-form';
import { InfoIcon } from 'lucide-react';
const ClientInformation = () => {
  const {
    register,
    formState: {
      errors
    },
    watch
  } = useFormContext();
  const existingClient = watch('clientInfo.existingClient');
  return <div className="space-y-8" data-id="element-350">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-351">
        <p className="text-slate-700" data-id="element-352">
          Please provide your personal information. This information will be
          used to prepare your Will and Power of Attorney documents.
        </p>
      </div>
      <div className="space-y-6" data-id="element-353">
        {/* Existing Client */}
        <div data-id="element-354">
          <div className="flex items-center mb-2" data-id="element-355">
            <label className="text-navy-800 font-medium" data-id="element-356">
              Are you an existing client?
            </label>
          </div>
          <div className="flex items-center space-x-4" data-id="element-357">
            <label className="inline-flex items-center" data-id="element-358">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('clientInfo.existingClient')} data-id="element-359" />
              <span className="ml-2" data-id="element-360">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-361">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('clientInfo.existingClient')} data-id="element-362" />
              <span className="ml-2" data-id="element-363">No</span>
            </label>
          </div>
        </div>
        {/* How did you hear about us */}
        <div data-id="element-364">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-365">
            How did you hear about us?
          </label>
          <select className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" {...register('clientInfo.referralSource')} data-id="element-366">
            <option value="" data-id="element-367">Please select</option>
            <option value="referral" data-id="element-368">Referral from friend/family</option>
            <option value="search" data-id="element-369">Google search</option>
            <option value="social" data-id="element-370">Social media</option>
            <option value="advertisement" data-id="element-371">Advertisement</option>
            <option value="other" data-id="element-372">Other</option>
          </select>
        </div>
        {/* Full Legal Name */}
        <div data-id="element-373">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-374">
            Full Legal Name
            <span className="text-red-500 ml-1" data-id="element-375">*</span>
          </label>
          <input type="text" className={`w-full px-3 py-2 border ${errors.clientInfo?.fullName ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} placeholder="Enter your full legal name" {...register('clientInfo.fullName')} data-id="element-376" />
          {errors.clientInfo?.fullName && <p className="text-red-500 text-sm mt-1" data-id="element-377">
              {errors.clientInfo.fullName.message as string}
            </p>}
          <p className="text-slate-500 text-sm mt-1" data-id="element-378">
            Please provide your full legal name as it appears on official
            documents.
          </p>
        </div>
        {/* Age */}
        <div data-id="element-379">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-380">
            Age
            <span className="text-red-500 ml-1" data-id="element-381">*</span>
          </label>
          <input type="number" className={`w-full px-3 py-2 border ${errors.clientInfo?.age ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} placeholder="Enter your age" {...register('clientInfo.age')} data-id="element-382" />
          {errors.clientInfo?.age && <p className="text-red-500 text-sm mt-1" data-id="element-383">
              {errors.clientInfo.age.message as string}
            </p>}
        </div>
        {/* Marital Status */}
        <div data-id="element-384">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-385">
            Marital Status
            <span className="text-red-500 ml-1" data-id="element-386">*</span>
          </label>
          <select className={`w-full px-3 py-2 border ${errors.clientInfo?.maritalStatus ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} {...register('clientInfo.maritalStatus')} data-id="element-387">
            <option value="" data-id="element-388">Please select</option>
            <option value="married" data-id="element-389">Married</option>
            <option value="commonLaw" data-id="element-390">Common Law</option>
            <option value="divorced" data-id="element-391">Divorced</option>
            <option value="widowed" data-id="element-392">Widowed</option>
            <option value="single" data-id="element-393">Single</option>
          </select>
          {errors.clientInfo?.maritalStatus && <p className="text-red-500 text-sm mt-1" data-id="element-394">
              {errors.clientInfo.maritalStatus.message as string}
            </p>}
        </div>
        {/* Address */}
        <div data-id="element-395">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-396">
            Address
            <span className="text-red-500 ml-1" data-id="element-397">*</span>
          </label>
          <textarea className={`w-full px-3 py-2 border ${errors.clientInfo?.address ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} rows={3} placeholder="Enter your current address" {...register('clientInfo.address')} data-id="element-398" />
          {errors.clientInfo?.address && <p className="text-red-500 text-sm mt-1" data-id="element-399">
              {errors.clientInfo.address.message as string}
            </p>}
        </div>
        {/* Phone Number */}
        <div data-id="element-400">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-401">
            Phone Number
            <span className="text-red-500 ml-1" data-id="element-402">*</span>
          </label>
          <input type="tel" className={`w-full px-3 py-2 border ${errors.clientInfo?.phone ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} placeholder="(123) 456-7890" {...register('clientInfo.phone')} data-id="element-403" />
          {errors.clientInfo?.phone && <p className="text-red-500 text-sm mt-1" data-id="element-404">
              {errors.clientInfo.phone.message as string}
            </p>}
        </div>
        {/* Email */}
        <div data-id="element-405">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-406">
            Email
            <span className="text-red-500 ml-1" data-id="element-407">*</span>
          </label>
          <input type="email" className={`w-full px-3 py-2 border ${errors.clientInfo?.email ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} placeholder="your.email@example.com" {...register('clientInfo.email')} data-id="element-408" />
          {errors.clientInfo?.email && <p className="text-red-500 text-sm mt-1" data-id="element-409">
              {errors.clientInfo.email.message as string}
            </p>}
          <p className="text-slate-500 text-sm mt-1" data-id="element-410">
            We'll use this email to communicate with you about your documents.
          </p>
        </div>
        {/* Employment Information Section */}
        <div className="pt-4" data-id="element-411">
          <div className="flex items-center mb-4" data-id="element-412">
            <h3 className="text-lg font-medium text-navy-900" data-id="element-413">
              Employment Information
            </h3>
            <div className="ml-2 group relative" data-id="element-414">
              <InfoIcon size={16} className="text-slate-500" data-id="element-415" />
              <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block bg-navy-800 text-white text-xs p-2 rounded w-64" data-id="element-416">
                This information helps us understand your employment situation
                for estate planning purposes.
              </div>
            </div>
          </div>
          {/* Occupation */}
          <div className="mb-4" data-id="element-417">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-418">
              Occupation
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter your occupation" {...register('clientInfo.occupation')} data-id="element-419" />
          </div>
          {/* Employer Name */}
          <div className="mb-4" data-id="element-420">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-421">
              Employer Name
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter your employer's name" {...register('clientInfo.employerName')} data-id="element-422" />
          </div>
          {/* Business Address */}
          <div className="mb-4" data-id="element-423">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-424">
              Business Address
            </label>
            <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Enter your business address" {...register('clientInfo.businessAddress')} data-id="element-425" />
          </div>
          {/* Business Phone */}
          <div className="mb-4" data-id="element-426">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-427">
              Business Phone
            </label>
            <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register('clientInfo.businessPhone')} data-id="element-428" />
          </div>
        </div>
        {/* Citizenship */}
        <div data-id="element-429">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-430">
            Citizenship(s)
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Canadian, American" {...register('clientInfo.citizenship')} data-id="element-431" />
          <p className="text-slate-500 text-sm mt-1" data-id="element-432">
            Please list all countries of citizenship. This information is
            important for tax and estate planning purposes.
          </p>
        </div>
      </div>
    </div>;
};
export default ClientInformation;